module.exports = __webpack_public_path__ + "static/media/HPNM03.005fba66.jpg";